import images from "@assets/images";
import { DimensionContext } from "@src/DimensionProvider";
import { useAppDispatch, useAppSelector } from "@src/ducks/ducksHook";
import { useLobbyService } from "@src/ducks/hooks";
import { authActions } from "@src/ducks/slices/auth.slice";
import { selectedMissionClaimed } from "@src/ducks/slices/lobby.slice";
import { ImageButton } from "components/button";
import React from "react";

const Mission = () => {
  const dispatch = useAppDispatch();
  const {onChangeScreen} = useLobbyService();
  const { hudHeight } = React.useContext(DimensionContext);
  const isMissionBonusClaimed = useAppSelector(selectedMissionClaimed);

  const onSetErrorMessage = React.useCallback((value: string) => {
    dispatch(authActions.setErrorMessage(value));
  }, [dispatch]);

  const onMission = () => {
    if (isMissionBonusClaimed) {
      onSetErrorMessage("You’ve already claimed your reward today.\n Come back next week for new missions.");
    } else {
      onChangeScreen({ screen: "mission" });
    }
  };

  return (
    <ImageButton
      onPress={onMission}
      source={{uri: images["btn-mission"]}}
      style={[{width: hudHeight * 1.5, height: hudHeight * 1.26 }]}
    />
  );
};

export default React.memo(Mission);
